<template>
    <div class="table-list">
        <div class="btn-group clearfix">
        </div>
        <table border="0" cellpadding="0" cellspacing="0" width="100%" summary="쪽지 상담 리스트" class="consult-memo-list">
            <caption style="display: none;">간단 문의 리스트</caption>
            <colgroup>
                <col width="30%">
                <col width="15%">
                <col width="40%">
                <col width="15%">
            </colgroup>
            <thead>
                <tr>
                    <th>의사/병원</th>
                    <th>상담구분</th>
                    <th>내용</th>
                    <th>작성일자</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="memo in consult_memo_list" :class="{'on': (memo.memo_id == current_memo_id)}" @click="chosen_row(memo)" :key="memo.memo_id">
                    <td>
                        <p>{{ memo.dr_name }}</p>
                    </td>
                    <td class="clearfix">
                        <p>{{ memo.consult_type_name }}</p>
                    </td>
                    <td class="clearfix">
                        <p class="content">{{ memo.content }}</p>
                    </td>                
                    <td>{{ memo.created_at | date_format('YYYY-MM-DD (dd) HH:mm') }}</td>
                </tr>
            </tbody>
        </table>

        <v-pagination v-model="page_no"
            :page-count="total_page"
            :classes="bootstrapPaginationClasses"
            :labels="customLabels"
            @change="load_list(page_no)">
        </v-pagination>
    </div>
</template>

<script>
import { nameByConstMixin } from '@/lib/mixins'
import vPagination from '@/components/Common/Paging.vue'

export default {
    mixins: [ nameByConstMixin ],
    name: 'consult-memo-list',
    props: ['notes', 'is_click'],
    data () {
      return {
        //chk_chosen: false,
        
        consult_memo_list: [],
        current_memo_id: 0, //선택한 row의 memo_id
        
        //페이징 관련
        total_count: 0, //총 건수
        total_page: 1, //총 페이지 번호
        page_no : 1, //현재 페이지 번호
        bootstrapPaginationClasses: {
            ul: 'pagination',
            li: 'page-item',
            liActive: 'active',
            liDisable: 'disabled',
            button: 'page-link'
        },
        customLabels: {
            first: 'First',
            prev: 'Previous',
            next: 'Next',
            last: 'Last'
        }
      }
    },
    computed: {
        // ...mapState(['account'])
    },
    methods: {
        chosen_row (memo) {
            this.current_memo_id = memo.memo_id;
            this.$emit('onSelectRow', memo);
        },

        async load_list(page_no = 1){
            let params = {
                page : page_no,
            }
            
            await this.axios({
                method: 'get',
                url: '/consult_memo_all',
                params: params,
            }).then((response) => {
                //console.log(response);
                if(!response.data.has_error){ //성공  
                    if(response.data.resp.list){
                        this.consult_memo_list = response.data.resp.list;
                    }
                    this.total_count = response.data.resp.total_count
                    this.total_page = Math.ceil(this.total_count / 10);
                }else{ //실패
                }
            }).catch((error) => {
                console.log('error!: ', error);
            }).finally(() => {
                
            });
        }
    },
    updated() {
        this.$nextTick(function () {
            // if(!this.chk_chosen) {
            //     console.log('[ConsultNoteList]nextTick : note_id = ', this.notes[0].note_id);
            //     this.chosen_row(this.notes[0]) // 모든 화면이 렌더링된 후 실행합니다.
            //     this.chk_chosen = false //조건 변경 시 제일 처음상담건 선택을 위해 20200305 kjw
            // }


            // console.log("[ConsultNoteList]nextTick is_click = ", this.is_click);
            // if(this.is_click && this.notes[0]) {
            //     this.chosen_row(this.notes[0]) // 모든 화면이 렌더링된 후 실행합니다.
            // }
            // this.$emit('setClick', true);
        })
    },
    mounted() {
        //console.log(this.notes);
        this.load_list();
    },
    components: {
        vPagination
    }
  }
</script>

<style scoped>
    .consult-memo-list thead {
        width: 100%;
        height: 50px;
        border-bottom: 1px solid #e7e7e9;
    }

    .consult-memo-list thead th {
        color: #b8b8b8;
        font: 500 13px/50px 'Noto Sans KR', sans-serif;
    }

    .consult-memo-list tbody tr {
        height: 58px;
        background-color: #fff;
        cursor: pointer;
        border-bottom: 1px solid #e7e7e9;
    }

    .consult-memo-list tbody tr:hover,
    .consult-memo-list tbody tr.on {
        background-color: #f5f6fa;
    }

    .consult-memo-list tbody td {
        text-align: center;
        vertical-align: middle;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .consult-memo-list tbody td .note-comment {
        float: left;
        text-align: left;
    }
    
    /* 글자수 제한, width 초과하면 ...로 보여줌 */
    .content {
        white-space: nowrap;
        width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>